export default __webpack_public_path__ + "static/media/avatar-basic-silver.91822f84.svg";